export const CAPACITY = {
    /* Europort — the garage at the terminal. Floors are bare numbers in the
       database; M is the mezzanine; outside_entry / outside_exit are the two
       kerbside strips, which is why they carry more traffic than any floor. */
    /* The owner, 30 October 2026: our own places are 7. patro 34, M 18, 8. patro 4 and
       venku 31 (the two kerbside strips together, not counted apart) — 87 in all, was the
       legacy panel's 86. In a busy week other tenants of the garage lend us places on other
       floors; those are arranged by hand and carry no capacity here (0). */
    europort: {
        total: 87,
        zoneGroups: { venku: { places: 31, zones: ['outside_entry', 'outside_exit'] } },
        zones: {
            outside_exit: 0, //   15 643 použití (with outside_entry: 31, see zoneGroups)
            M: 18, //              8 973
            '7': 34, //            7 051
            outside_entry: 0, //   2 683
            '8': 4, //               572
            '9': 0, //               187
            '4': 0, //               169
            '3': 0, //                64
            '11': 0, //               32
            '10': 0, //               29
            '13': 0, //               27
            '2': 0, //                16
            '6': 0, //                 4
            '5': 0, //                 4
            '12': 0, //                1
        },
    },
    /* Tuchoměřice — two numbers on the legacy panel, "Venku 203 / 483" and
       "+ Garáž 38 / 71", and 483 + 71 is the 554 below. The owner confirmed
       both on 2 September 2026. The garage is the two halls; everything else —
       the grass, the gravel, the square, the entrance, the rows under and behind
       the hall — is outside. Same rule as POP: every zone in exactly one list. */
    /* The owner's zone list, 30 October 2026 (photo of the yard plan): 14 zones, 471 cars in all,
       "480 if we really try". Hala 1 + Hala 2 = the garage (72); the rest is outside (399).
       'Za halou 2', 'Tráva' and 'Gravel' are old spellings still found on rows — not on his list, 0.
       Replaces the legacy panel's 483 / 71 (2 September 2026). */
    tuchomerice: {
        total: 471,
        /* Per-zone places are not counted; the two section totals are. */
        zones: {
            'Hala 1': 43, //         55
            'Tráva E': 35, //        53
            'Šterk': 46, //          51
            'Pod halou 1': 43, //    49
            'Tráva D': 33, //        40
            'Náměstí': 35, //        39
            'Tráva F': 54, //        38
            'Tráva B': 33, //        37
            'Tráva C': 32, //        34
            'Tráva A': 32, //        33
            'Hala 2': 29, //         33
            'Vjezd': 14, //          32
            'Za halou 2': 0, //     16
            'Pod halou 2': 28, //    14
            'Pod recepcí': 14, //    11
            'Tráva': 0, //           1
            'Gravel': 0, //          1
        },
        sections: [
            {
                key: 'venku',
                label: 'Tuchoměřice venku',
                total: 399,
                zones: [
                    'Tráva E', //         53
                    'Šterk', //           51
                    'Pod halou 1', //     49
                    'Tráva D', //         40
                    'Náměstí', //         39
                    'Tráva F', //         38
                    'Tráva B', //         37
                    'Tráva C', //         34
                    'Tráva A', //         33
                    'Vjezd', //           32
                    'Za halou 2', //      16
                    'Pod halou 2', //     14
                    'Pod recepcí', //     11
                    'Tráva', //            1
                    'Gravel', //           1
                ],
            },
            {
                key: 'garaz',
                label: 'Tuchoměřice garáž',
                total: 72,
                zones: [
                    'Hala 1', //          55
                    'Hala 2', //          33
                ],
            },
        ],
    },
    /* POP — the legacy panel splits this one in two, "Venku 262 / 150" and
       "Garáž 281 / 650", and 150 + 650 is the 800 below. The split maps onto
       the zone names: "Před POPem …" is the strip in front, "POP …" is inside.
       The owner asked for those two cards back, so `sections` below draws them.
       Every POP zone has to appear in exactly one of the two lists — the checks
       will not let one be forgotten or listed twice. */
    /* The owner's zone list, 30 October 2026: official / what fits in practice —
       POP 1 17/27, POP 2–7 36/40 each, POP 8 36/44 (the entrance), Před POPem 1 70/74,
       2 72/76, 3 72/76, 4 71/77. Garage 269 official (307 in practice), outside 285 (303);
       610 at the very most. Replaces the legacy panel's 150 / 650. */
    pop: {
        total: 554,
        sections: [
            {
                key: 'venku',
                label: 'POP venku',
                total: 285,
                /* The strip in front of the building. Four numbered rows plus the
                   un-numbered "Před POPem", which is what was written before anyone
                   numbered them and is still in use. */
                zones: ['Před POPem 1', 'Před POPem 2', 'Před POPem 3', 'Před POPem 4', 'Před POPem'],
            },
            {
                key: 'garaz',
                label: 'POP garáž',
                total: 269,
                /* Inside. Eight numbered floors, six lettered bays and the office
                   space, which does hold cars however it reads. */
                zones: [
                    'POP 1',
                    'POP 2',
                    'POP 3',
                    'POP 4',
                    'POP 5',
                    'POP 6',
                    'POP 7',
                    'POP 8',
                    'POP A',
                    'POP B',
                    'POP C',
                    'POP G',
                    'POP R',
                    'POP S',
                    'POP Kancl',
                ],
            },
        ],
        zones: {
            'Před POPem 2': 72, //   95
            'Před POPem 1': 70, //   68
            'Před POPem 4': 71, //   62
            'Před POPem 3': 72, //   52
            'POP 8': 36, //          50
            'Před POPem': 0, //     49
            'POP 6': 36, //          43
            'POP 2': 36, //          43
            'POP 5': 36, //          42
            'POP 3': 36, //          40
            'POP 4': 36, //          38
            'POP 7': 36, //          35
            'POP 1': 17, //          27
            'POP B': 0, //           7
            'POP S': 0, //           3
            'POP R': 0, //           3
            'POP G': 0, //           2
            'POP C': 0, //           2
            'POP Kancl': 0, //       1
            'POP A': 0, //           1
        },
        zonesMax: {
            'POP 1': 27, 'POP 2': 40, 'POP 3': 40, 'POP 4': 40, 'POP 5': 40, 'POP 6': 40, 'POP 7': 40, 'POP 8': 44,
            'Před POPem 1': 74, 'Před POPem 2': 76, 'Před POPem 3': 76, 'Před POPem 4': 77,
        },
    },
    /* Kněževes — eight numbered blocks, evenly used, which is what a yard that
       is filled in rotation looks like.
  
       300, not the 500 the legacy panel prints. The 500 was never right: the
       person who runs the yard put it at 300 on 2 September 2026, in writing,
       and the owner took that number the same day. The legacy panel also shows
       0 cars there — Kněževes is not tracked by the old system at all, which is
       why the LPR project exists for that yard and no other. */
    /* The owner, 30 October 2026: "about 285", not yet split into zones. */
    knezeves: {
        total: 285,
        zones: {
            'Kněževes K1': 0, //    46
            'Kněževes K2': 0, //    38
            'Kněževes K7': 0, //    35
            'Kněževes K6': 0, //    33
            'Kněževes K5': 0, //    33
            'Kněževes K4': 0, //    27
            'Kněževes K8': 0, //    25
            'Kněževes K3': 0, //    25
        },
    },
    /* Šestka — one reservation in the whole staging extract has ever been
       parked here, so there is exactly one zone name to go on. The site is
       real and the legacy panel gives it 216 places; the zone list below is
       thin because the yard is barely used, not because anything is missing. */
    sestka: {
        total: 216,
        zones: {
            'Šestka 2': 0, //        1
        },
    },
};
/** The keys the settings screen offers, in panel order, with their shipped values. */
export function capacityKeys() {
    const out = [];
    for (const site of ['europort', 'tuchomerice', 'pop', 'knezeves', 'sestka']) {
        const c = CAPACITY[site];
        if (c.sections && c.sections.length) {
            for (const sec of c.sections)
                out.push({ key: `${site}/${sec.key}`, label: sec.label, shipped: sec.total });
        }
        else {
            out.push({ key: site, label: SITE_LABEL_LOCAL[site], shipped: c.total });
        }
    }
    return out;
}
const SITE_LABEL_LOCAL = {
    europort: 'Europort',
    tuchomerice: 'Tuchoměřice',
    pop: 'POP',
    knezeves: 'Kněževes',
    sestka: 'Šestka',
};
function sectionTotal(site, sec, o) {
    const v = o?.[`${site}/${sec.key}`];
    return typeof v === 'number' && v >= 0 ? v : sec.total;
}
export function siteCapacity(site, o) {
    if (site === null)
        return 0;
    const c = CAPACITY[site];
    if (!c)
        return 0;
    // A site drawn as sections is the sum of its sections, so an edited
    // section moves the site's total with it — the panel's "celkem" and the
    // cards it adds up must never disagree.
    if (c.sections && c.sections.length) {
        let n = 0;
        for (const sec of c.sections)
            n += sectionTotal(site, sec, o);
        return n;
    }
    const v = o?.[site];
    return typeof v === 'number' && v >= 0 ? v : c.total;
}
/** Places at one named zone, or 0 when nobody has counted it. */
export function zoneCapacity(site, zone) {
    if (site === null)
        return 0;
    const c = CAPACITY[site];
    if (!c)
        return 0;
    const n = c.zones[zone];
    return typeof n === 'number' && n > 0 ? n : 0;
}
/**
 * Turn the per-site fold into the cards the occupancy panel draws.
 *
 * For four of the five sites this is a rename: one bucket becomes one card
 * carrying the site's capacity. POP becomes two, its zones dealt out by the
 * lists in `sections`.
 *
 * A zone that matches no section gets a card of its own rather than being
 * dropped or quietly counted on the wrong half. The checks make that
 * impossible for any place the yards currently record, so the card is there
 * for the place somebody invents next month: it appears on the screen, with
 * no capacity, under a heading that says nobody has filed it yet.
 */
export function splitIntoCards(buckets, o) {
    const out = [];
    for (const b of buckets) {
        const cap = b.site === null ? undefined : CAPACITY[b.site];
        const sections = cap && cap.sections ? cap.sections : undefined;
        if (!sections || sections.length === 0) {
            out.push({
                key: b.site === null ? ' none' : b.site,
                site: b.site,
                label: b.label,
                total: b.total,
                capacity: siteCapacity(b.site, o),
                zones: b.zones,
            });
            continue;
        }
        /* Zone name to section index, built once for the site rather than
           scanned per zone — this runs on every refresh of the dashboard. */
        const where = new Map();
        for (let i = 0; i < sections.length; i++) {
            for (const z of sections[i].zones)
                where.set(z, i);
        }
        const dealt = sections.map(() => []);
        const leftover = [];
        for (const z of b.zones) {
            const i = where.get(z.zone);
            if (i === undefined)
                leftover.push(z);
            else
                dealt[i].push(z);
        }
        for (let i = 0; i < sections.length; i++) {
            let n = 0;
            for (const z of dealt[i])
                n += z.count;
            out.push({
                key: `${b.site}/${sections[i].key}`,
                site: b.site,
                label: sections[i].label,
                total: n,
                capacity: sectionTotal(b.site, sections[i], o),
                zones: dealt[i],
            });
        }
        if (leftover.length > 0) {
            let n = 0;
            for (const z of leftover)
                n += z.count;
            out.push({
                key: `${b.site}/ jinde`,
                site: b.site,
                label: `${b.label} – nezařazeno`,
                total: n,
                capacity: 0,
                zones: leftover,
            });
        }
    }
    return out;
}
export function zoneCapacitySum(site) {
    const c = CAPACITY[site];
    if (!c)
        return 0;
    let n = 0;
    for (const k of Object.keys(c.zones)) {
        const v = c.zones[k];
        if (typeof v === 'number' && v > 0)
            n += v;
    }
    return n;
}
